// extracted by mini-css-extract-plugin
module.exports = {"new__container":"qXFs","image":"PA4S","new__content":"snRG","label":"PdFe","title":"OZUl","time":"yWng","time__svg":"dWKG"};